/* eslint-disable camelcase */
/*
 * @Author: edvardchen
 * @Date:   2017-04-18 14:35:32
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-07-30 19:39:42
 */

// @flow
import _ from 'lodash';
import querystring from 'query-string';
import { isIOS } from '@tencent/qb-article-util/lib/UA';
import { getQBVersion, isomorphicConfig, getQIMEI36, promiseTimeout, getAndroidID, getOAID } from '../utility';
import { get, post } from './fetch';
import axios from 'axios';
type RecommInfo = {
  docId: string,
  url: string,
  count: number,
  version: number,
  platform: number,
  isBaiPai: string,
  subjectId: string,
  qimei: string,
  isPush: string,
  grayIds: string,
  ext?: Object,
};
export function getUgInfo({
  docId = '',
  extInfo = {},
  tagInfo,
  subjectId,
  ugExtInfo = {},
}: {
  docId: string,
  extInfo?: Object,
  ugExtInfo?: Object,
  tagInfo: string,
  subjectId: string,
}) {
  return post('/api/articles/getUgInfo', {
    body: {
      docId,
      subjectId,
      tagInfo,
      extInfo: JSON.stringify(extInfo),
      ugExtInfo: JSON.stringify(ugExtInfo),
    },
  });
}

export function getBriefAndPostInfo({ docId, url }: { docId: string, url?: string }) {
  return post('/api/articles/brief_postinfo', {
    body: {
      docId,
      url,
    },
  });
}

/**
 * 获取文章的相关阅读
 */
export function getCorrelatedNews({ docId }: { docId: string }) {
  const params = querystring.stringify({ docId, limit: 3 });
  return get(`/api/articles/correlated?${params}`);
}
/**
 * 相关阅读上报服务

export function correlatedNewsReport({ type, info }:{type:string, info:string}) {
  const params = querystring.stringify({
    type,
    info
  });
  return get(`/api/articles/correlatedReport?${params}`);
}
 */
export function getArticleTags({ docId, ch = '' }: { docId: string, ch?: string }) {
  const params = querystring.stringify({ docId, ch });
  return get(`/api/articles/tags?${params}`);
}

export function getRecommForShare({ docId, url, limit }: { docId: string, url: string, limit: number }) {
  const params = querystring.stringify({ url, docId, limit });
  return get(`/api/articles/recommforshare?${params}`);
}

export function getContentAndBrief({ docId, ...rest }: { docId: string }) {
  return get(`/api/articles/${docId}?${querystring.stringify(rest)}`);
}

export const getAdInCorrelated = ({ url, subjectId }: { url: string, subjectId?: string }) =>
  post('/api/ad/article/correlated', {
    body: {
      url,
      subjectId,
    },
  });

/**
 * 获取正文大图广告
 * @param {string} url 文章原网址
 * @param {string} docId
 * @param {string} spn 用户网络类型
 */
export function getBigAd({ docId, url, subjectId }: { docId: string, url: string, subjectId?: string }) {
  return post('/api/ad/article/big', {
    body: {
      docId,
      url,
      subjectId,
    },
  });
}

export function getMixAd({ docId, url, subjectId, grayId, locName, cashFlag, cashInfo, articleTags }: *) {
  return post('/api/ad/article/mix', {
    body: {
      docId,
      url,
      subjectId,
      grayId,
      locName,
      cashFlag,
      cashInfo,
      articleTags,
    },
  });
}
/**
 * 获取灰度策略接口
 */
export function getGrayConfig() {
  return get('/api/gray/config');
}

/**
 * 拉取精探数据
 * @param {string} url 当前页面URL
 * */
export function exploreForNewsBottom({ url }: { url: string }) {
  return post('/api/articles/exploreForNewsBottom', {
    body: { url },
  });
}

/**
 * 拉取世界杯竞猜小卡片数据
 * @param {string} url 当前页面URL
 * */
export function getDocMatchGuessData({ url, qbid, matchId }: { url: string, qbid: string, matchId: string }) {
  return post('/api/circles/getDocMatchGuessData', {
    body: { url, qbid, matchId },
  });
}

/**
 * 拉取世界杯竞猜小卡片数据
 * @param {string} url 当前页面URL
 * */
export function getGuessDetailPage({ url, qbid }: { url: string, qbid: string }) {
  return post('/api/articles/getGuessDetailPage', {
    body: { url, qbid },
  });
}

/**
 * 参与竞猜
 * @param {string} url 当前页面URL
 * */
export function guess({ url, qbid }: { url: string, qbid: string }) {
  return post('/api/circles/guess', {
    body: { url, qbid },
  });
}
export function fetchGoodsImg(docId: string) {
  return window
    .fetch(`//life.html5.qq.com/news/imgRecGoods?docid=${docId}`)
    .then((resp) => resp.json())
    .then((resp) => {
      if (resp.ret === 0) {
        const { data } = resp;
        if (!_.isEmpty(data)) {
          return data;
        }
      }
      console.log(resp);
      return {};
    })
    .catch((e) => {
      console.log(e);
      return {};
    });
}

/**
 * 精探上报
 * @param {string} url 当前页面URL
 * @param {string} items 上报条目
 * */
export function exploreReport({ url, items }: { url: string, items: string }) {
  return post('/api/articles/exploreReport', {
    body: { url, items },
  });
}

/**
 * 获取小程序的配置信息
 */
export function getMiniProgramConfig() {
  return get('/api/gray/miniProgramConfig');
}

/**
 * 获取小程序数据
 */
export function getMiniProgramByTags(vecTag: Array<Object>, mpType: Array<number>, docId: string) {
  return post('/api/articles/getMiniProgramByTags', {
    body: {
      vecTag: JSON.stringify(vecTag),
      mpType: JSON.stringify(mpType),
      docId,
    },
  });
}
/**
 * 获取ABTest产品配置数据
 */
export function getGrayPolicyInfo() {
  return post('/api/articles/getGrayPolicyInfo', {
    body: {},
  });
}
export function getExtInfo() {
  return post('/api/articles/getExtInfo', {
    body: {},
  });
}
/**
 * 获取文章的负反馈信息
 */
export function getListAppFeedback(docId: string) {
  return post('/api/articles/getListAppFeedback', {
    body: { docId },
  });
}
/**
 * 获取相关推荐和精探合并数据
 */
export function getRecommendMergeInfo({
  docId,
  url,
  count,
  version,
  platform,
  isBaiPai,
  subjectId,
  qimei,
  grayIds,
  isPush,
  ext,
}: RecommInfo) {
  return post('/api/articles/getRecommendMergeInfo', {
    body: {
      docId,
      url,
      count,
      version,
      platform,
      subjectId,
      isBaiPai,
      qimei,
      grayIds,
      isPush,
      ext: encodeURIComponent(JSON.stringify(ext)),
    },
  });
}
/**
 *
 * 获取疫情蓝条信息
 */
export function getBlueTip({ url, qimei, pvNum, lbs }: { url: string, qimei: string, pvNum: number, lbs: string }) {
  return post('/api/articles/getBlueTip', {
    body: {
      url,
      qimei,
      pvNum,
      lbs,
    },
  });
}
/**
 * 获取wifi管家相关推荐列表
 */
export function getWifiCorrelatedInfo(params: Object) {
  return post('/api/wifisdk/correlated', {
    body: { ...params },
  });
}
/**
 * 变更文章当前在读人数
 */
export function updateArticleReadingUsers(docId: string, direction: number) {
  return post('/api/caches/articleReadingUsers', {
    body: { docId, direction },
  });
}
/**
 *
 * 获取快报屏蔽策略
 */
export function getDistributeInfo({ qbid, wifi, type = '1' }: { qbid: string, wifi: string, type?: string }) {
  return post('/api/articles/getDistributeInfo', {
    body: { qbid, wifi, type },
  });
}
export function getNowLivingFetch(roomid: number) {
  const ua = window.navigator.userAgent || '';
  const version = getQBVersion();
  const clienttype = isIOS(ua) ? 1 : 2;
  const params = querystring.stringify({
    roomid,
    clienttype,
    version,
    fromid: 3048,
  });
  return get(`${isomorphicConfig.nowliveHost}/cgi-bin/ilive_guide/get_anchor_live_info?${params}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}
export async function newsReportPv(type: number, data: Object) {
  const qimei36 = await promiseTimeout(getQIMEI36);
  const oaid = await promiseTimeout(getOAID);
  const androidId = await promiseTimeout(getAndroidID);
  const logData = {
    ...(type === 0
      ? {
          F24: `qimei36=${qimei36};oaid=${oaid};android_id=${androidId}`,
          oaid,
          android_id: androidId,
        }
      : {
          F25: `qimei36=${qimei36};oaid=${oaid};android_id=${androidId}`,
          oaid,
          android_id: androidId,
        }),
    ...data,
  };
  return post('/api/articles/newsReport', {
    body: {
      type,
      logData: JSON.stringify(logData),
    },
  });
}
export function getVideoInfoByMd5(str: string, imageUrl: string, url: string) {
  return post('/api/articles/getVideoInfoByMd5', {
    body: {
      value: str,
      imageUrl,
      url,
    },
  });
}

/**
 * 获取作者的相关推荐
 */
export function getInsertRecommList({
  docId,
  accountId,
  accountLevel,
  qbid,
  channelId,
  appId,
}: {
  docId: string,
  accountId: string,
  accountLevel: string,
  qbid: string,
  channelId: string,
  appId: string,
}) {
  return post('/api/articles/getInsertRecommList', {
    body: { docId, accountId, accountLevel, qbid, channelId, appId },
  });
}
export function getCorrelateVideo({
  qbid,
  docId,
  ch,
  pid,
  tagList,
  num,
}: {
  qbid: string,
  docId: string,
  ch: string,
  pid: string,
  tagList: string,
}) {
  return post('/api/articles/getCorrelateVideo', {
    body: { qbid, docId, ch, pid, tagList, num },
  });
}
export function getVideoInfo4Article({ str, imageUrl, url }: *) {
  return new Promise(async (resolve) => {
    try {
      // let hasResult = false;
      let result = {};
      result = await getVideoInfoByMd5(str, imageUrl, url);
      if (result && !_.isEmpty(result)) {
        const { vid, cdnPlayInfo = {} } = result;
        if (vid) {
          const { playUrls = [] } = cdnPlayInfo;
          result = Object.assign(result, {
            playUrls,
            version: 'imageVideo',
            innerCh: 1064,
          });
          // hasResult = true;
        }
      }
      /* if (!hasResult) {
        const list = tags.map((info) => {
          const { name, score, id } = info || {};
          return { tag_id: id, tag_name: name, weight: score };
        });
        const tagList = encodeURIComponent(JSON.stringify(list));
        result = await getCorrelateVideo({ qbid, docId, ch, pid, tagList });
        const { recomm_info = [] } = result || {};
        if (recomm_info && recomm_info.length) {
          const vidInfo = recomm_info[0] || {};
          if (vidInfo) {
            const { image_url, runtime, vid, title, cdn_info, play_url } = vidInfo || {};
            const { play_urls = [] } = cdn_info || {};
            result = {
              imageUrl: image_url,
              title,
              totalTime: runtime,
              vid,
              playUrls: play_urls,
              version: 'correlateVideoB',
              innerCh: 1063,
              playUrl: play_url,
            };
          }
        }
      } */
      resolve(result || {});
    } catch (error) {
      console.error('getVideoInfo4Article', error);
      resolve({});
    }
  });
}
export function reportHotHistory(docIds) {
  return post('/api/articles/authorHotHistory', {
    body: { docIds: JSON.stringify(docIds) },
  });
}
export function reportAccountRecomHistory(accountIds) {
  return post('/api/articles/accountRecomHistory', {
    body: { accountIds: JSON.stringify(accountIds) },
  });
}

// 获取推荐卡片内容
export function fetchRecommendBarInfo(guid, qua, docId, deviceInfo, grayConfig) {
  const params = {
    guid,
    qua,
    type: 2,
    pushId: docId,
    deviceInfo,
  };
  const cgiUrl =
    grayConfig.env === 'real'
      ? 'https://delivery.kandian.qq.com/trpc.kd_category_center.push_resource_server.GetContentService/GetContent'
      : 'https://tdelivery.kandian.qq.com/trpc.kd_category_center.push_resource_server.GetContentService/GetContent';
  return window
    .fetch(cgiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    })
    .then((resp) => resp.json());
  // return {
  //   errMsg: 'ok',
  //   errCode: 0,
  //   content: {
  //     contentId: '162044110909893',
  //     title: '女子25层阳台外跳舞坠楼，三亚警方通报：房间内留有遗书',
  //     imgUrl: 'http://qqpublic.qpic.cn/qq_public_cover/0/0-2095683124-277FABD1F772ADDF2E432DC3E0E1E8CC_vsmcut/0',
  //     url:
  //       'http://post.mp.qq.com/kan/video/201365806-1526094f34c524bk-w3244hagk3k.html?_wv=2281701505\u0026sig=2dd736adfb89548088f5fc9a6c5e5a73\u0026time=1620374701',
  //     views: '1000次观看',
  //     contentType: 1,
  //   },
  // };
}
/**
 * ### 看点图文相关 ===START====
 */
export function getContentAndBriefKd({ docId, ...rest }: { docId: string }) {
  return get(`/api/articles/${docId}?${querystring.stringify(rest)}`);
}
export function getPraiseInfo(data) {
  return post('/api/articles/getPraiseInfo', {
    body: { data: JSON.stringify(data) },
  });
}
export function setPraiseKd(params) {
  return axios({
    method: 'POST',
    url: 'https://we.kandian.qq.com/trpc.tkdwb.like_operate_svr.LikeOperateSvr/SetLike',
    data: params,
  })
    .then((res) => {
      return res;
    })
    .catch((e) => console.log(e));
}
/**
 * ### 看点图文相关 ===END====
 */
export function getHideArticleRowkeys() {
  // 获取当天0点的时间戳
  const date = new Date(new Date().toLocaleDateString()).getTime();
  // 筛选出时间符合要求并且是QQ浏览器或者全部平台的数据
  const filter = encodeURIComponent(`deadtime>${date}&app='2'|deadtime>${date}&app='4'`);
  return get(
    `https://v.qq.com/cache/wuji/object?filter=${filter}&datetime=timestamp&appid=kandian_privilege_conf&schemaid=zan_blacklist&schemakey=7b62b8b180d343c493d682c0caf4a6c4`,
    { credentials: false },
  );
}
export function getMixinData(data) {
  return post('/api/articles/getMixinData', {
    body: { data: JSON.stringify(data) },
  });
}
